import http from '@axios'
import axios from 'axios';
import {getUserToken, getUserData} from "@/helpers/Utils";

const endpoint = `/user`;
const ep_search_user = `${process.env.VUE_APP_PB_API}/ags/page-user`;
const ep_get_user_detail = `${process.env.VUE_APP_PB_API}/ags/page-user/detail`;
const ep_update_member_user = `${process.env.VUE_APP_PB_API}/ags/page-user/update/member`;
const ep_update_access_level_user = `${process.env.VUE_APP_PB_API}/ags/page-user/update/role`;
const ep_delete_user_by_id = `${process.env.VUE_APP_PB_API}/ags/page-user/delete/user`;
const ep_update_sim_ktp = `${process.env.VUE_APP_PB_API}/ags/page-user/update/driver/sim-ktp`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": "listUser"
  },
  "data": {
    "member": 1,
    "status": 0
  }
};

const listUser = (data) => {
  const user = getUserData();
  body.req.op = 'listUser';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}

const setUserStatus = (data) => {
  const user = getUserData();
  body.req.op = 'setUserStatus';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  const defaultData = {
    username: '', status: 0,
  }
  body.data = {... defaultData, ...data}
  return http.post(endpoint, body);
}

const addUser = (data) => {
  const user = getUserData();
  body.req.op = 'addUser';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}


const getUser = (username) => {
  body.req.op = 'getUser';
  body.req.token = getUserToken();
  body.data = {
    username,
  }
  return http.post(endpoint, body);
}

const setPassword = (data) => {
  const user = getUserData();
  body.req.op = 'setPassword';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}

const searchUser = (data) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${ep_search_user}/${data.category}/${data.search}`,
    headers: {
        'Content-Type': 'application/json'
    },
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const getUserDetail = (data) => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${ep_get_user_detail}/${data}`,
    headers: {
        'Content-Type': 'application/json'
    },
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const memberUserUpdate = (data) => {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${ep_update_member_user}`,
    headers: {
        'Content-Type': 'application/json'
    },
    data: JSON.stringify(data),
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const accessLevelUserUpdate = (data) => {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${ep_update_access_level_user}`,
    headers: {
        'Content-Type': 'application/json'
    },
    data: JSON.stringify(data),
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const deleteUserById = (data) => {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${ep_delete_user_by_id}`,
    headers: {
        'Content-Type': 'application/json'
    },
    data: JSON.stringify(data),
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const updateSim = (data) => {
  // data: { user_id, file }
  const form = new FormData();
  // expect `file` to be a File/Blob (from browser)
  form.append('sim', data.file || data.sim);

  const url = `${ep_update_sim_ktp}/${data.user_id}`;
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url,
    data: form,
    // In browser axios will set the Content-Type with boundary automatically
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const updateKtp = (data) => {
  // data: { user_id, file }
  const form = new FormData();
  form.append('ktp', data.file || data.ktp);

  const url = `${ep_update_sim_ktp}/${data.user_id}`;
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url,
    data: form,
  }

  return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

export { 
  updateSim, updateKtp,
  deleteUserById, accessLevelUserUpdate,
  searchUser, getUserDetail, memberUserUpdate,
  listUser, setUserStatus, addUser, getUser, setPassword, 
}
